import { render, staticRenderFns } from "./EditDownloadSettingsModal.vue?vue&type=template&id=a47aa80e"
import script from "./EditDownloadSettingsModal.vue?vue&type=script&lang=js"
export * from "./EditDownloadSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a47aa80e')) {
      api.createRecord('a47aa80e', component.options)
    } else {
      api.reload('a47aa80e', component.options)
    }
    module.hot.accept("./EditDownloadSettingsModal.vue?vue&type=template&id=a47aa80e", function () {
      api.rerender('a47aa80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/EditDownloadSettingsModal.vue"
export default component.exports